import React, { useState, useEffect } from 'react';
import { DiscordWidget } from './discord-widget';
import { TeamspeakWidget } from './teamspeak-widget';

/**
 * hält den Open-State beider Voice-Widgets,
 * damit immer nur eines gleichzeitig geöffnet ist
 */
const VoiceWidgets = () => {
  const [openWidget, setOpenWidget] = useState(null);

  // Klick irgendwo außerhalb der Widgets schließt das offene Panel
  useEffect(() => {
    if (!openWidget) return undefined;

    const handleClick = event => {
      if (!event.target.closest('[data-voice-widget]')) {
        setOpenWidget(null);
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [openWidget]);

  return (
    <>
      <DiscordWidget
        serverId={`${process.env.GATSBY_DISCORD_SERVER}`}
        invite={`${process.env.GATSBY_DISCORD_INVITE}`}
        open={openWidget === 'discord'}
        onToggle={open => setOpenWidget(open ? 'discord' : null)}
      />
      <TeamspeakWidget
        url={process.env.GATSBY_TS_PROXY}
        join={process.env.GATSBY_TS_JOIN}
        open={openWidget === 'teamspeak'}
        onToggle={open => setOpenWidget(open ? 'teamspeak' : null)}
      />
    </>
  );
};

export { VoiceWidgets };
